import axios from 'axios'

export const getProviders = ({ commit }) => {
  commit('setLoading', true);
  axios.get('/api/providers/getProviders')
    .then(response => {
      commit('getProviders', response.data.data)
    })
    .catch(e => {
      console.error('providers/getProviders:', e);
      commit('getProviders', []);
    })
    .finally(() => {
      commit('setLoading', false);
    });
}
